import fraudFA from './fa/fa.json'

const FraudMessages = {
  fa: { ...fraudFA },
}

export default FraudMessages
